import { render, staticRenderFns } from "./IsanonLogo.vue?vue&type=template&id=0df7277d&scoped=true"
import script from "./IsanonLogo.vue?vue&type=script&lang=js"
export * from "./IsanonLogo.vue?vue&type=script&lang=js"
import style0 from "./IsanonLogo.vue?vue&type=style&index=0&id=0df7277d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df7277d",
  null
  
)

export default component.exports